(function(){
  /******VIDEO REVIEWS SLIDER*******/


  const instaSlider = new Swiper(".instFeed",{
    spaceBetween: 0,
    breakpoints: {
      320: {
        slidesPerView: 2.15
      },
      480: {
        slidesPerView: 2.15
      },
      750: {
        slidesPerView: 3
      },
      1024: {
        slidesPerView: 4
      },
      1440: {
        slidesPerView: 6
      }
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    }
  })

})();

